import { ShieldCheck, Lock, Zap, Check } from "lucide-react";
import { CHECKOUT_URL } from "@/lib/constants";

export default function Offer() {
    return (
        <section
            id="oferta"
            data-testid="section-offer"
            className="bg-cream py-24 lg:py-32 relative"
        >
            <div className="max-w-4xl mx-auto px-5 sm:px-8 lg:px-12">
                <div className="text-center max-w-3xl mx-auto reveal">
                    <div className="flex items-center justify-center gap-3 mb-5">
                        <span className="hairline w-10" />
                        <span className="label-eyebrow">A oferta</span>
                        <span className="hairline w-10" />
                    </div>
                    <h2 className="font-serif text-emerald-brand text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
                        O preço de um almoço.
                        <br />O retorno de uma{" "}
                        <span className="italic text-gold-brand">
                            vida inteira
                        </span>
                        .
                    </h2>
                </div>

                <div className="mt-14 bg-white border-2 border-gold-brand rounded-3xl overflow-hidden shadow-2xl reveal">
                    <div className="bg-emerald-brand text-cream py-4 text-center text-sm uppercase tracking-[0.25em] font-bold">
                        Oferta de lançamento · por tempo limitado
                    </div>

                    <div className="p-8 sm:p-12">
                        <div className="text-center">
                            <p className="text-emerald-light/70">
                                De{" "}
                                <span className="line-through">R$ 97</span> por
                                apenas
                            </p>
                            <div className="mt-3 flex items-end justify-center gap-2">
                                <span className="font-serif text-gold-brand text-2xl mb-3">
                                    R$
                                </span>
                                <span className="font-serif text-emerald-brand text-7xl sm:text-8xl leading-none">
                                    47
                                </span>
                            </div>
                            <p className="mt-2 text-emerald-light/80">
                                ou 5x de R$ 10,84 no cartão
                            </p>
                        </div>

                        <ul className="mt-10 grid sm:grid-cols-2 gap-3 max-w-xl mx-auto">
                            {[
                                "E-book completo com o método",
                                "Plano prático de 30 dias",
                                "Mais de 80 páginas aplicáveis",
                                "Acesso vitalício e atualizações",
                                "Acesso imediato por e-mail",
                                "Garantia incondicional de 7 dias",
                            ].map((item, i) => (
                                <li
                                    key={i}
                                    className="flex items-start gap-3 text-emerald-brand"
                                >
                                    <Check className="w-5 h-5 text-gold-brand shrink-0 mt-0.5" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>

                        <div className="mt-10 flex justify-center">
                            <a
                                href={CHECKOUT_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="cta-offer"
                                className="btn-gold pulse-gold text-base sm:text-lg w-full max-w-md justify-center"
                            >
                                Sim, quero destravar agora
                            </a>
                        </div>

                        <div className="mt-7 flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-emerald-light/80">
                            <span className="flex items-center gap-2">
                                <Lock className="w-4 h-4 text-emerald-light" />
                                Pagamento 100% seguro
                            </span>
                            <span className="flex items-center gap-2">
                                <Zap className="w-4 h-4 text-emerald-light" />
                                Acesso imediato
                            </span>
                            <span className="flex items-center gap-2">
                                <ShieldCheck className="w-4 h-4 text-emerald-light" />
                                7 dias de garantia
                            </span>
                        </div>
                    </div>
                </div>

                {/* Garantia */}
                <div className="mt-14 bg-emerald-brand text-white rounded-3xl p-8 sm:p-10 flex flex-col sm:flex-row items-center gap-7 reveal">
                    <div className="shrink-0 w-20 h-20 rounded-full bg-gold-brand flex items-center justify-center">
                        <ShieldCheck className="w-10 h-10 text-emerald-brand" />
                    </div>
                    <div className="text-center sm:text-left">
                        <p className="label-eyebrow text-gold-brand">
                            Garantia de 7 dias
                        </p>
                        <h3 className="mt-2 font-serif text-2xl sm:text-3xl leading-tight">
                            Se em 7 dias você achar que não vale, devolvemos
                            100% do seu dinheiro.
                        </h3>
                        <p className="mt-3 text-white/80 leading-relaxed">
                            Sem perguntas, sem burocracia. O risco é todo nosso
                            — porque sabemos que o método funciona.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
